import { tv } from "tailwind-variants";

/** Styles for the overlay that covers the viewport for modal dialogs. */
export const modalOverlay = tv({
  base: "group fixed inset-0 z-10 data-[rac]:h-[var(--visual-viewport-height)]",
});
